import keys from './keys';

export const mutationBuilder = obj => Object.assign(
    Object.keys(keys).reduce((acc, key) => {
        acc[key] = (state, payload) => {
            state[key] = payload;
        }
        return acc;
    }, {}),
    obj
);

export const stateBuilder = obj => {
    for (let [key, value] of Object.entries(keys)) {
        obj[key] = value;
    }
    return obj;
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Marketing/helpers/builder.js